export default "<div class=\"download-url\">\n  <a [href]=\"url\" download>\n    <ng-content select=\".app-download-content\"></ng-content>\n  </a>\n</div>\n"